import * as types from './action-types';
import { filter } from 'lodash';
import { settings } from '../templates/circle-vertical';

const ChartState = () => ({
  generations: settings.generations,
  angle: settings.angle,
  angleOffset: settings.angleOffset,
  margin: 340,
  font: settings.font,
  background: null,
  strokeWidth: settings.strokeWidth,
  strokeColor: '#f1f1f1',
  textTransform: 'none',
  thematic: null,
  heading: {
    text: '',
    margin: 80,
    fontSize: 80,
    fontFamily: 'Cinzel',
    textColor: '#202020',
  },
  subheading: {
    text: '',
    margin: 0,
    fontSize: 75,
    fontFamily: 'Cinzel',
    textColor: '#666',
  },
});

export function chartReducer(state = ChartState(), {payload, type}) {
  switch (type) {
    case types.SET_ANGLE:
      return Object.assign({}, state, {
        angle: payload,
      });

    case types.SET_ANGLE_OFFSET:
      return Object.assign({}, state, {
        angleOffset: payload,
      });

    case types.SET_GENERATIONS:
      return Object.assign({}, state, {
        generations: payload,
      });

    case types.SET_FONT:
      return Object.assign({}, state, {
        font: payload,
      });

    case types.SET_MARGIN:
      return Object.assign({}, state, {
        margin: payload,
      });
    
    case types.SET_STROKE_WIDTH:
      return Object.assign({}, state, {
        strokeWidth: payload,
      });

    case types.SET_STROKE_COLOR:
      return Object.assign({}, state, {
        strokeColor: payload,
      });
    
    case types.SET_CHART_BACKGROUND:
      return Object.assign({}, state, {
        background: payload,
      });

    case types.SET_TEXT_TRANSFORM:
      return Object.assign({}, state, {
        textTransform: payload,
      });

    case types.SET_THEMATIC:
      return Object.assign({}, state, {
        thematic: payload,
      });

    case types.SET_HEADING:
      return Object.assign({}, state, {
        heading: payload,
      })

    case types.SET_SUBHEADING:
      return Object.assign({}, state, {
        subheading: payload,
      })

    case types.BATCH_UPDATE_CHART:
      return Object.assign({}, state, payload)
    
    default: 
      return state;

  }
}


// WEBPACK FOOTER //
// ./src/core/chart/reducer.js